export const FEATURE_PRICING_PAGE_CTA = 'IDEAGROW-26-pricing-page-cta'

export const TRIAL_CTA_VARIANTS = {
  control: 'control',
  pricingPage: 'pricing-page',
} as const

export type TrialCtaVariant = (typeof TRIAL_CTA_VARIANTS)[keyof typeof TRIAL_CTA_VARIANTS]
